import React, { Component, createRef } from 'react'

import PropTypes from 'prop-types';
import { propTypes, withFormsy } from 'formsy-react';
import './DGAddressAutoFill.less'
import loader from '../../../assets/images/newui/loader.gif'
import Config from 'Config';
import Geocode from 'react-geocode';
import { Icon, Search, Modal } from 'semantic-ui-react';

const myLocation = { resultID: 'my', title: 'Select current location' }
/**
 * Textbox for dealgrace
 * @augments {Component<Props, State>}
 */
class DGAddressAutoFill extends Component {
  constructor(props) {
    super(props);
    this.inputRef = createRef();
    this.state = {
      query: '',
      results: [],
      searchingAddress: false,
      inputLabelClassname: 'dgaddress-label',
      openResults: false,
      finalValue: '',
      lat: 0,
      lon: 0,
      usingCurrentLocation: false,
      openResults: false,
      locationError: false,
      overlay: false
    };
    this.autoComplete;
    this.geocoder;
    this.fieldRef = createRef();
  }
  componentDidMount() {

    /*const googleScript = document.getElementById('google-map-script')

    if (window.google) {
        console.log('window.google found');
        this.handleScriptLoad(this.setQuery, this.inputRef)
    }
  
    googleScript.addEventListener('load', () => {
        console.log('script loaded now')
        this.handleScriptLoad(this.setQuery, this.inputRef)
    })*/
    console.log('in component did mount')
    /*this.loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${Config.maps.key}&libraries=places`,
      () => this.handleScriptLoad(this.setQuery, this.inputRef),
      '__googleMapsScriptId'
    );*/

    
    this.setState({ finalValue: this.props.value, inputLabelClassname: `dgaddress-label on-focus` }, () => {
      if (!this.autoComplete) {
        this.handleScriptLoad();
      }
    })
    
  }

  componentDidUpdate = (prevProps) => {

    if (!_.isEmpty(this.props.value) && _.isEmpty(this.state.finalValue)) {
      if (!this.autoComplete) {
        this.handleScriptLoad();
      }
      this.setState({ finalValue: this.props.value, inputLabelClassname: `dgaddress-label on-focus` })
    }
  }

  setQuery = (query) => {
    this.setState({ query: query })
  }

  setupCallback = (script, callback) => {
    if (script.readyState) {
      console.log(script.readyState);
      script.onreadystatechange = function () {
        console.log(script.readyState)
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null
          console.log('in script.onreadystatechange')
          callback()
        }
      }
    } else {
      script.onload = () => {
        callback();
      }
    }
  }

  loadScript = (url, callback, id) => {
    let script;
    if (document.getElementById(id)) {
      // If the script already exists then add the new callback to the existing one
      script = document.getElementById(id);
      const oldFunc = script.onload;
      this.setupCallback(script, () => {
        oldFunc && oldFunc();
        callback();
      })
    } else {
      console.log('in else')
      // If the script doesn't exists then create it
      script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
      script.setAttribute('id', id)
      this.setupCallback(script, callback)
      document.getElementsByTagName('head')[0].appendChild(script)
    }
  }

  handleScriptLoad(updateQuery, autoCompleteRef) {
    
    this.autoComplete = new google.maps.places.AutocompleteService();
    this.geocoder = new google.maps.Geocoder();
    //console.log(this.autoComplete);

    //this.autoComplete.getPlacePredictions({ input: "1411" }, this.displaySuggestions);

    /*this.autoComplete = new window.google.maps.places.Autocomplete(
        this.inputRef.current,
      { types: ["geocode"], componentRestrictions: { country: "us" } }
    );
    
    this.autoComplete.setFields(["address_components", "formatted_address"]);
    this.autoComplete.addListener("place_changed", () =>
      this.handlePlaceSelect(updateQuery)
    );*/
  }



  handlePlaceSelect = async (updateQuery) => {
    const addressObject = this.autoComplete.getPlace();
    const query = addressObject.formatted_address;
    // /updateQuery(query);
    console.log(addressObject);
  }

  changeValue = (event, data) => {
    /*this.props.setValue(event.currentTarget.value);
    if (this.props.onChange) {
        this.props.onChange(event, { name: this.props.name, value: event.currentTarget.value });
    }*/
    this.setState({ query: event.currentTarget.value })
    //this.setQuery(event.currentTarget.value);
  };


  onSearchChange = (e, { value }) => {

    //search only when location modal is not visible and the current location is being selected in which case we show loader over the field.
    if (!this.state.overlay && !this.state.locationError) {
      this.setState({ query: value, searchingAddress: true, finalValue: '' });
      this.props.setValue('');
      if (this.fetchAddressTimer)
        clearTimeout(this.fetchAddressTimer);

      this.fetchAddressTimer = setTimeout(() => {
        console.log('in settimeout')
        if (this.state.query.length > 0) {
          console.log('this.autocomplete', this.autoComplete);
          if (this.autoComplete) {
            console.log('get place predicton')
            this.autoComplete.getPlacePredictions({ input: this.state.query, componentRestrictions: { country: "us" } }, this.displaySuggestions);
          }
        }
        else {
          let results = [myLocation];
          this.setState({ query: '', finalValue: '', results: results, openResults: true });
        }
      }, 500)
    }

  }


  displaySuggestions = (predictions, status) => {
    if (status != google.maps.places.PlacesServiceStatus.OK || !predictions) {
      //alert(status);
      return;
    }
    let results = predictions.map(result => {
      return { id: result.place_id, title: result.description };
    });

    let predictionsCount = results.length;

    results = [myLocation, ...results];

    this.setState({ results: results, openResults: true }, () => {
      if (this.fieldRef.current) {
        this.scrollToElement();
      }

      // if(predictionsCount == 1){
      //   this.onSelection(results[1].title);
      // }

    });
  }

  resultsRenderer = ({ resultID, title }) => {
    return <>
      <div className='result-icon'>{resultID == 'my' ? <svg id="Current_Location_Icon_" data-name="Current Location Icon !" xmlns="http://www.w3.org/2000/svg" width="52.286" height="52.27" viewBox="0 0 52.286 52.27">
        <g id="Group_15665" data-name="Group 15665" transform="translate(0 0)">
          <path id="Path_41873" data-name="Path 41873" d="M23.787,3.958c0-.538-.006-1.075,0-1.613A2.342,2.342,0,0,1,26.065,0,2.305,2.305,0,0,1,28.5,2.2c.052,1.121.019,2.246.023,3.369,0,.367,0,.369.358.417A20.328,20.328,0,0,1,46.047,22.047c.1.506.185,1.017.264,1.528.023.15.085.188.229.188,1.109-.005,2.219-.009,3.329,0a2.368,2.368,0,1,1,.087,4.735c-1.123.018-2.247.008-3.37,0-.178,0-.245.042-.271.23a19.945,19.945,0,0,1-7.132,12.985,20.044,20.044,0,0,1-9.412,4.425c-.332.062-.666.114-1,.146-.189.018-.254.079-.252.276q.014,1.633,0,3.267A2.364,2.364,0,0,1,23.8,50c-.033-1.15-.013-2.3-.006-3.453,0-.182-.062-.233-.23-.252a18.227,18.227,0,0,1-6.028-1.733A20.159,20.159,0,0,1,6.208,30.051c-.093-.43-.154-.868-.21-1.306-.024-.186-.082-.25-.278-.249-1.13.009-2.261.02-3.39,0A2.222,2.222,0,0,1,.309,27.271a2.275,2.275,0,0,1,.071-2.4A2.308,2.308,0,0,1,2.451,23.76c.917,0,1.833,0,2.75,0,.193,0,.386-.005.579,0,.125,0,.179-.029.195-.167a19.091,19.091,0,0,1,2.26-7.105A20.264,20.264,0,0,1,16.76,8.105a19.947,19.947,0,0,1,6.847-2.14c.141-.018.183-.07.181-.208-.006-.6,0-1.2,0-1.8Zm-13.1,19.8h.289c.965,0,1.93,0,2.894,0a2.375,2.375,0,0,1,2.144,3.512A2.253,2.253,0,0,1,13.97,28.5c-1,.021-2,.005-3,.006h-.28a15.665,15.665,0,0,0,13.094,13.09c0-.127,0-.209,0-.29,0-1.013-.014-2.026.006-3.039a2.366,2.366,0,1,1,4.729.171c.007.965,0,1.93,0,2.895,0,.079.008.158.013.263A15.813,15.813,0,0,0,41.614,28.5h-.27c-1.013,0-2.026.015-3.039-.006a2.368,2.368,0,0,1,.117-4.734c.979-.008,1.957,0,2.936,0,.078,0,.157-.007.238-.011A15.577,15.577,0,0,0,28.522,10.7c0,.091,0,.179,0,.267,0,1.041.028,2.083-.019,3.121a2.361,2.361,0,0,1-4.716-.2c-.009-.985,0-1.971,0-2.957v-.265a15.345,15.345,0,0,0-8.649,4.366,15.6,15.6,0,0,0-4.451,8.728" transform="translate(0 0)" fill="#666" />
          <path id="Path_41874" data-name="Path 41874" d="M244.419,250.064a5.942,5.942,0,1,1,5.919,5.948,5.933,5.933,0,0,1-5.919-5.948" transform="translate(-224.207 -223.939)" fill="#666" />
        </g>
      </svg> : <Icon name='map marker alternate' />}</div>
      <div className='result-text'>{title}</div></>


  }

  onSearchFocus = () => {
    if (_.isEmpty(this.state.finalValue)) {
      let results = [];
      if (!this.state.overlay) {
        if (_.isEmpty(this.state.results)) {
          results = [myLocation];
        }
        else {
          results = this.state.results;
        }

        this.setState({ inputLabelClassname: `dgaddress-label on-focus`, results: results, openResults: true }, () => {
          this.scrollToElement();
        })
      }
    }
    else {
      console.log('ethay')  
      this.setState({ inputLabelClassname: `dgaddress-label on-focus`, openResults: false }, () => {
        this.scrollToElement();
      })
    }
  }

  scrollToElement = () => {
    const offsetTop = this.fieldRef.current.parentNode.offsetTop;
    const container = document.querySelector(this.props.scrollableParentSelector);
    if (container) {
      container.scrollTo(0, offsetTop);
    }
  }

  onSearchBlur = () => {

    if (_.isEmpty(this.state.finalValue)) {
      this.setState({ inputLabelClassname: this.state.overlay || this.state.query.length > 0 ? `dgaddress-label on-focus` : `dgaddress-label`, openResults: false });
    }
    else {
      this.setState({ inputLabelClassname: `dgaddress-label on-focus`, openResults: false })
    }

  }

  onResultSelect = (e, data) => {
    console.log(e)
    
    this.setState({overlay: true, openResults: false, inputLabelClassname: `dgaddress-label on-focus`})
    if (data.result.resultID == 'my') {
      navigator.geolocation.getCurrentPosition(this.getCurrentPositionSuccess, this.getCurrentPositionFailure);
    }
    else {
      this.onSelection(data.result.title, 0, 0, false);

    }
  }

  getCurrentPositionSuccess = async (position) => {
    //let a = await Geocode.fromLatLng(position.coords.latitude, position.coords.longitude, Config.maps.key);
    if(this.geocoder){
      const latlng = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    
      try {
        const goecodingResponse = await this.geocoder.geocode({ location: latlng });
        
        if (goecodingResponse.results && goecodingResponse.results[0] ) {
          this.onSelection(goecodingResponse.results[0].formatted_address, position.coords.latitude, position.coords.longitude, true);
        }
      } catch (e) {
        // handle exception
        //console.log(e)
      }
    }
    //this.onSelection(a.results[0].formatted_address, position.coords.latitude, position.coords.longitude, true);
  }

  getCurrentPositionFailure = (a) => {
    console.log(a)
    this.setState({ lat: '', lon: '', usingCurrentLocation: false, locationError: true, overlay: false, inputLabelClassname: this.state.overlay || this.state.query.length > 0 ? `dgaddress-label on-focus` : `dgaddress-label`, openResults: false });


  }

  onSelection = (finalValue = '', lat = 0, lon = 0, usingCurrentLocation = false) => {
    this.setState({ lat: lat, lon: lon, usingCurrentLocation: usingCurrentLocation, finalValue: finalValue, openResults: false, overlay: false, inputLabelClassname: `dgaddress-label on-focus` });
    this.props.setValue(finalValue);
    if (this.props.onChange) {
      this.props.onChange(null, { name: this.props.name, value: finalValue });
    }
  }

  onResetClick = () => {
    this.setState({query: '', finalValue: '', usingCurrentLocation: false, lat: 0,  lon: 0, results: [], inputLabelClassname: `dgaddress-label`});
    this.props.setValue('');
  }

  closeLocationError = () => {
    this.setState({locationError: false});
  }

  render() {

    let inputClassName = 'dgaddress-autofill';
    let labelClassName = 'dgaddress-label';
    if (this.props.icon) {
      inputClassName += ' icon';
      labelClassName += ' icon';
    }
    if ((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) {
      inputClassName += ' error';
    }
    return (
      <div className={`field ${this.state.overlay? 'no-pointer-events' : ''}`} ref={this.fieldRef}>
        {this.props.icon &&
          <img src={this.props.icon} />
        }

        <Search
          minCharacters={3}
          onSearchChange={this.onSearchChange}
          results={this.state.results}
          resultRenderer={this.resultsRenderer}
          onFocus={this.onSearchFocus}
          onBlur={this.onSearchBlur}
          placeholder={this.props.placeholder}
          selectFirstResult
          onResultSelect={this.onResultSelect}
          open={this.state.openResults}
          value={_.isEmpty(this.state.finalValue) ? this.state.query : this.state.finalValue}
          className={inputClassName}
          

        ></Search>




        <div className={this.state.inputLabelClassname}><span>{this.props.label}</span>
          {this.props.placeholder && <span> ({this.props.placeholder})</span>}
          {!this.props.placeholder && <span></span>}
        </div>
        {((!this.props.isValid && !this.props.isPristine && this.props.isFormSubmitted) || (this.props.validExternally === false)) && <div className="error-label">{this.props.errorMessage || this.props.externalErrorMessage}</div>}
        {
          !_.isEmpty(this.state.finalValue) && <div className="dgaddress-autofill-reset" onClick={this.onResetClick}><Icon name='close' /></div>
        }
        
        {this.props.showRequired &&
          <div className="dgaddress-autofill-required">*</div>
        }
        {this.state.overlay && <div className='overlay'>
          <img src={loader} />
        </div>
        }

        {this.props.showLoader &&
          <div className="loader"><img src={loader}></img></div>
        }

        {this.state.locationError && <Modal open={true}
          closeIcon={true}
          closeOnDimmerClick={false}
          onClose={this.closeLocationError}
          className={"existing-email-notification-modal "}>
          <Modal.Content>
            <div className="main-msg">
              Location Access Needed
            </div>
            <div className="sub-msg">
                Your browser has blocked location access. Current location cannot be selected until permission is granted to access location.
              <br />
            </div>
          </Modal.Content>
        </Modal>}
      </div>
    )
  }
}

DGAddressAutoFill.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  ...propTypes
};

export default withFormsy(DGAddressAutoFill)
